import { createContext, useCallback, useContext, useRef, useState } from "react";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription,
  AlertDialogFooter, AlertDialogCancel, AlertDialogAction,
} from "@/components/ui/alert-dialog";

const ConfirmCtx = createContext(() => Promise.resolve(true));

// ask({ title, description, confirmLabel, destructive }) -> Promise<boolean>
export function ConfirmProvider({ children }) {
  const [opts, setOpts] = useState(null);
  const resolver = useRef(null);
  const ask = useCallback((o) => new Promise((res) => { resolver.current = res; setOpts(o); }), []);
  const close = (v) => { resolver.current?.(v); resolver.current = null; setOpts(null); };

  return (
    <ConfirmCtx.Provider value={ask}>
      {children}
      <AlertDialog open={!!opts} onOpenChange={(o) => { if (!o) close(false); }}>
        <AlertDialogContent className="z-[100] border-slate-800 bg-[#0f172a] text-white" data-testid="confirm-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle data-testid="confirm-title">{opts?.title}</AlertDialogTitle>
            {opts?.description && <AlertDialogDescription className="text-slate-400" data-testid="confirm-description">{opts.description}</AlertDialogDescription>}
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={() => close(false)} className="border-slate-700 bg-transparent text-slate-200 hover:bg-slate-800 hover:text-white" data-testid="confirm-cancel">Go back</AlertDialogCancel>
            <AlertDialogAction onClick={() => close(true)} data-testid="confirm-ok"
              className={opts?.destructive ? "bg-red-600 text-white hover:bg-red-500" : "bg-blue-700 text-white hover:bg-blue-800"}>
              {opts?.confirmLabel || "Confirm"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </ConfirmCtx.Provider>
  );
}

export const useConfirm = () => useContext(ConfirmCtx);
